import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // 필요한 경우 인증 토큰 추가
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // 서버가 응답을 반환한 경우
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      // 요청이 전송되었지만 응답을 받지 못한 경우
      console.error('Network Error:', error.request);
    } else {
      // 요청 설정 중 오류 발생
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

const apiService = {
  // NVR 연결 관리
  getNvrConnections: () => api.get('/api/nvr-connections/'),
  getNvrConnection: (id) => api.get(`/api/nvr-connections/${id}/`),
  createNvrConnection: (data) => api.post('/api/nvr-connections/', data),
  updateNvrConnection: (id, data) => api.put(`/api/nvr-connections/${id}/`, data),
  deleteNvrConnection: (id) => api.delete(`/api/nvr-connections/${id}/`),
  testNvrConnection: (id) => api.post(`/api/nvr-connections/${id}/test_connection/`),

  // 재생 세션 관리
  getPlaybackSessions: () => api.get('/api/playback-sessions/'),
  getPlaybackSession: (id) => api.get(`/api/playback-sessions/${id}/`),
  createPlaybackSession: (data) => api.post('/api/playback-sessions/', data),
  stopPlaybackSession: (id) => api.post(`/api/playback-sessions/${id}/stop/`),
  getPlaybackSessionStatus: (id) => api.get(`/api/playback-sessions/${id}/status/`),
};

export default apiService; 